import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select
} from '@mui/material'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import '../scss/dropDown.scss'
import CloseIcon from '@mui/icons-material/Close'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
// import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { PHONE_GET_AVAILABLE_NUMBERS_URL } from '../constants'

function BootstrapDialogTitle(props) {
  const { children, onClose, ...other } = props

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 0,
            top: 0,
            color: (theme) => theme.palette.blue
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  )
}

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired
}
const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
      '&::-webkit-scrollbar': {
        width: '8px'
      },
      '&::-webkit-scrollbar-track': {
        background: '#ffff'
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#141d2b',
        borderRadius: '4px'
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#141d2b'
      }
    }
  }
}

const DropDown = (props) => {
  const {
    setTwilioUpdatedPhone,
    // alternateNumber,
    // setAlternateNumber,
    userToEdit
    // voiceMsg,
    // setVoiceMsg
  } = props

  const [phoneNumber, setPhoneNumber] = useState()
  const [twilioPhoneNumber, setTwilioPhoneNumber] = useState([])
  // const [teleError, setTeleError] = useState('')
  const [loading, setLoading] = useState(true)

  // useEffect(() => {
  //   // const defaultCountryCode = "US";
  //   // setAlternateNumber(`+${defaultCountryCode}`);

  //   if (alternateNumber !== null) {
  //     setAlternateNumber(alternateNumber)
  //   }
  // }, [])

  const handleChange = (e) => {
    const {
      target: { value }
    } = e
    setPhoneNumber(value)
    setTwilioUpdatedPhone(e.target.value)
  }

  // const handleAlternateNumberChange = (value) => {
  //   if (!value) {
  //     setTeleError('Please enter you telrephone number')
  //   } else {
  //     setTeleError('') // Clear the error if a valid value is entered
  //   }
  //   setAlternateNumber(value)
  // }

  useEffect(() => {
    // Fetch data from API
    const fetchUsers = async () => {
      const token = localStorage.getItem('token')
      try {
        const response = await fetch(PHONE_GET_AVAILABLE_NUMBERS_URL, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        if (!response.ok || response.status !== 200) {
          return { success: false, error: 'Invalid credentials' }
        } else {
          const responseData = await response.text()

          const deserializedData = JSON.parse(responseData)
          if (userToEdit?.telephone === null) {
            setTwilioPhoneNumber(deserializedData)
          } else {
            const array = [userToEdit?.telephone, ...deserializedData]
            setTwilioPhoneNumber(array)
            setPhoneNumber(userToEdit?.telephone)
            setTwilioUpdatedPhone(userToEdit?.telephone)
            setLoading(false)
          }
          return { success: true, error: null }
        }
      } catch (error) {
        console.error('User Data Error: ' + error)
      }
    }

    fetchUsers()
  }, [])

  if (loading) {
    return <div className="loaderTele"></div>
  }

  return (
    <div className='alignPhoneNumber'>
      <FormControl sx={{ m: 1, width: 1 }}>
        <InputLabel
          id="tel-number-label"
          style={{ borderRadius: '2rem' }}
          sx={{
            color: '#141d2b', // Default label color
            '&.Mui-focused': { color: '#141d2b' } // Keep color when focused
          }}
        >
          Tel. No.
        </InputLabel>
        <Select
          labelId="tel-number-label"
          id="demo-multiple-name"
          value={phoneNumber || ''}
          // value={userToEdit?.telephone}
          onChange={handleChange}
          input={
            <OutlinedInput
              label="Name"
              sx={{
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc' // Default border color
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc' // Border color on hover
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#ccc' // Border color when focused (clicked)
                }
              }}
            />
          }
          MenuProps={MenuProps}
          defaultValue={userToEdit?.telephone}
        >
          <MenuItem value="">None</MenuItem>
          {twilioPhoneNumber?.map((telephone, index) => (
            <MenuItem key={index} value={telephone}>
              {telephone}
            </MenuItem>
          ))}
        </Select>

        {/* <div style={{ marginTop: '1rem' }}>Enter an Alternate Number</div>

        <PhoneInput
          international
          countryCallingCodeEditable={false}
          defaultCountry="US"
          defaultValue={userToEdit?.alternateTelephone}
          value={userToEdit?.alternateTelephone}
          limitMaxLength={10}
          onChange={handleAlternateNumberChange}
          className='phoneNumberInput'
        />
        {teleError && (
          <p className="ms-4 mb-1" style={{ fontSize: 14, color: 'red' }}>
            {teleError}
          </p>
        )} */}

        {/* <TextField
          id="voice-message-basic"
          label="Voice Message"
          variant="outlined"
          fullWidth
          style={{ marginTop: '1rem' }}
          onChange={(e) => setVoiceMsg(e.target.value)}
          defaultValue={voiceMsg}
          multiline
        /> */}
      </FormControl>
    </div>
  )
}
export default DropDown
